"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.AppDownloadClickedSource=void 0;var o;(function(e){e.Home="home",e.OngoingOrderDetails="ongoing_order_details",e.Other="other"})(o||(exports.AppDownloadClickedSource=o={}));
//# sourceMappingURL=AppDownloadClickedSource.js.map
